import React from 'react';
import refactor from '../assests/robosoccer_refactor.jpeg' // Assuming you have an image file

const RobotArm = () => {
  return (
    <div className="w-full min-h-screen text-blue-light bg-gray-100 pt-[120px]">
      <div className="max-w-[900px] mx-auto p-8 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h1 className="text-4xl font-bold inline border-b-4 border-blue-dark text-blue-dark">
            RoboSoccer
          </h1>
          <p className="py-6 text-gray-700">
          Current software member on the RoboSoccer team at UofT.
          </p>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Refactor</h2>
          <p className="py-4 text-gray-600">
            My first task at this design team was to refactor code that was tied to ROS. 
            That is, most of the alogirthms were dependent on ROS being run, and could not be tested on their own, preventing rapid testing.
            Working under a graduate from UofT Robotics Engineering, I was introduced to code structures used in his workplace.
          </p>
          
          <p className="py-4 text-gray-600">
            The restructuring I completed allowed for the team to test changes quicker at competiton.
          </p>

          <div className="w-full h-96 md:w-full text-gray-600 shadow-lg">
                <div
                style={{ backgroundImage: `url(${refactor})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>
        </div>


        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Upgrading to YOLOv8</h2>
          <p className="py-4 text-gray-600">
            Currently working on upgrade object detection from YOLOv5 to v8 and potentially including segmentation for fieldline detection.
          </p>
        </div>

    
      </div>
    </div>
  );
};

export default RobotArm;
